//账单

export default [
    {   //库存库龄报表
        path: "inventory/age",
        name: "inventorAge",
        component: () => import(/* webpackChunkName: "bill" */ "@/views/inventory/age/index"),
    },
    {   //库存明细报表
        path: "inventory/list",
        name: "inventoryList",
        component: () => import(/* webpackChunkName: "bill" */ "@/views/inventory/list/index"),
    },
    {   //库存预留报表
        path: "inventory/reserve",
        name: "inventoryReserve",
        component: () => import(/* webpackChunkName: "bill" */ "@/views/inventory/reserve/index"),
    },
    {   //库存快照
        path: "inventory/snapshot",
        name: "inventorySnapshot",
        component: () => import(/* webpackChunkName: "bill" */ "@/views/inventory/snapshot/index"),
    },
    {   //库存变动明细报表
        path: "inventory/task",
        name: "inventoryTask",
        component: () => import(/* webpackChunkName: "bill" */ "@/views/inventory/task/index"),
    },
    {   //库存在途报表
        path: "inventory/transport",
        name: "inventoryTransport",
        component: () => import(/* webpackChunkName: "bill" */ "@/views/inventory/transport/index"),
    },
    {   //库存批次明细
        path: "inventory/batchlist",
        name: "inventoryBatchList",
        component: () => import(/* webpackChunkName: "bill" */ "@/views/inventory/batchlist/index"),
    },
    {   //库存批次快照
        path: "inventory/batchsnapshot",
        name: "inventoryBatchSnapshot",
        component: () => import(/* webpackChunkName: "bill" */ "@/views/inventory/batchsnapshot/index"),
    },
    {   //库存批次变动明细
        path: "inventory/batchtask",
        name: "inventoryBatchTask",
        component: () => import(/* webpackChunkName: "bill" */ "@/views/inventory/batchtask/index"),
    },
    {   //库存库龄报表（系统）
        path: "inventorySer/age",
        name: "inventorySerAge",
        component: () => import(/* webpackChunkName: "bill" */ "@/views/inventory/age/index"),
    },
    {   //库存明细报表（系统）
        path: "inventorySer/list",
        name: "inventorySerList",
        component: () => import(/* webpackChunkName: "bill" */ "@/views/inventory/list/index"),
    },
    {   //库存预留报表（系统）
        path: "inventorySer/reserve",
        name: "inventorySerReserve",
        component: () => import(/* webpackChunkName: "bill" */ "@/views/inventory/reserve/index"),
    },
    {   //库存快照（系统）
        path: "inventorySer/snapshot",
        name: "inventorySerSnapshot",
        component: () => import(/* webpackChunkName: "bill" */ "@/views/inventory/snapshot/index"),
    },
    {   //库存变动明细报表（系统）
        path: "inventorySer/task",
        name: "inventorySerTask",
        component: () => import(/* webpackChunkName: "bill" */ "@/views/inventory/task/index"),
    },
    {   //库存在途报表（系统）
        path: "inventorySer/transport",
        name: "inventorySerTransport",
        component: () => import(/* webpackChunkName: "bill" */ "@/views/inventory/transport/index"),
    },
    {   //库存批次明细（系统）
        path: "inventorySer/batchlist",
        name: "inventorySerBatchList",
        component: () => import(/* webpackChunkName: "bill" */ "@/views/inventory/batchlist/index"),
    },
    {   //库存批次快照（系统）
        path: "inventorySer/batchsnapshot",
        name: "inventorySerBatchSnapshot",
        component: () => import(/* webpackChunkName: "bill" */ "@/views/inventory/batchsnapshot/index"),
    },
    {   //库存批次变动明细（系统）
        path: "inventorySer/batchtask",
        name: "inventorySerBatchTask",
        component: () => import(/* webpackChunkName: "bill" */ "@/views/inventory/batchtask/index"),
    },
    {   //识别码
        path: "inventory/codeMap",
        name: "inventoryCodeMap",
        component: () => import(/* webpackChunkName: "bill" */ "@/views/inventory/codemap/index"),
    },

    {   //渠道库存明细
        path: "inventory/channel",
        name: "inventoryChanne;",
        component: () => import(/* webpackChunkName: "bill" */ "@/views/inventory/channel/index"),
    },
    {   //渠道库存明细（系统）
        path: "inventorySer/channel",
        name: "inventorySerChannel",
        component: () => import(/* webpackChunkName: "bill" */ "@/views/inventory/channel/index"),
    },
    {   //库存差异明细
        path: "inventory/warehouse",
        name: "inventorWarehouse",
        component: () => import(/* webpackChunkName: "bill" */ "@/views/inventory/warehouse/index"),
    },
    {   //库存差异明细（系统）
        path: "inventorySer/warehouse",
        name: "inventorySerWarehouse",
        component: () => import(/* webpackChunkName: "bill" */ "@/views/inventory/warehouse/index"),
    },
]


